<template>
    <div class='review-card'>
        <div class='line'></div>
        <div class='top-section'>
            <div>Rob A</div>
            <div>{{review.formatted_date}}</div>
        </div>
        <div v-show='review.verified_purchase == 1'><i class="fa-regular fa-circle-check verified-purchase-icon"></i> Verified purchase</div>
        <div>
            <Ratings :rating='review.rating'/>
        </div>
        <div class='user-review'>
            {{review.review}}
        </div>

        <div class='helpful'>
            {{review.helpful_count}} people found this review helpful
        </div>
    </div>
</template>

<script>
import Ratings from '@/ecom/components/products/single_product/reviews/Ratings.vue';

export default {
    components:{Ratings},
    props: ['review']
}
</script>

<style lang="scss" scoped>
.review-card{
    // width: 1000px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    @media(max-width: 768px){
        width: 80vw;
    }
}

.top-section{
    display: flex;
    justify-content: space-between;
    font-size: 0.96rem;
}

.verified-purchase-icon{
    color: #2b8a3e;
}

.helpful{
    display:flex;
    justify-content: flex-end;
    color: var(--primary-colour-1);
}

.line{
    width: 100%;
    height: 1px;
    background-color: #dee2e6;
}
</style>